module.exports = __webpack_public_path__ + "img/b0454b6.svg";